import { useState, useCallback } from 'react';

export interface UseConfirmDialogProps {
  onConfirm: () => void | Promise<void>;
  onCancel?: () => void;
}

export interface UseConfirmDialogReturn {
  isOpen: boolean;
  handleOpen: () => void;
  handleConfirm: () => Promise<void>;
  handleCancel: () => void;
}

export const useConfirmDialog = ({
  onConfirm,
  onCancel,
}: UseConfirmDialogProps): UseConfirmDialogReturn => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleConfirm = useCallback(async () => {
    await onConfirm();
    setIsOpen(false);
  }, [onConfirm]);

  const handleCancel = useCallback(() => {
    onCancel?.();
    setIsOpen(false);
  }, [onCancel]);

  return {
    isOpen,
    handleOpen,
    handleConfirm,
    handleCancel,
  };
};
